var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3210_7957)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M512 0.5H0V256.5H512V0.5Z",
    fill: "#FF4B55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512 256.5H0V511.5H512V256.5Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.577 135.683C134.577 92.2998 166.41 56.3408 207.975 49.6888C210.232 49.3278 210.334 46.2228 208.107 45.7098C197.817 43.3428 186.887 42.6698 175.537 44.2158C130.705 50.3218 96.0525 89.1178 95.4185 134.359C94.6955 186.016 136.341 228.08 187.755 228.08C194.753 228.08 201.55 227.262 208.088 225.759C210.312 225.248 210.201 222.135 207.947 221.775C166.396 215.126 134.577 179.233 134.577 135.683Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.658 158.896L204.753 170.606L192.409 170.702C190.811 170.714 190.148 172.754 191.434 173.703L201.364 181.036L197.64 192.805C197.158 194.329 198.893 195.59 200.193 194.659L210.235 187.481L220.277 194.659C221.577 195.588 223.312 194.328 222.83 192.805L219.106 181.036L229.036 173.703C230.321 172.754 229.659 170.714 228.061 170.702L215.717 170.606L211.812 158.896C211.307 157.38 209.163 157.38 208.658 158.896Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.673 158.896L265.768 170.606L253.424 170.702C251.826 170.714 251.163 172.754 252.449 173.703L262.379 181.036L258.655 192.805C258.173 194.329 259.908 195.59 261.208 194.659L271.25 187.481L281.292 194.659C282.592 195.588 284.327 194.328 283.845 192.805L280.121 181.036L290.051 173.703C291.336 172.754 290.674 170.714 289.076 170.702L276.732 170.606L272.827 158.896C272.323 157.38 270.179 157.38 269.673 158.896Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.44 64.7376L235.535 76.4476L223.191 76.5436C221.593 76.5556 220.93 78.5956 222.216 79.5446L232.146 86.8776L228.422 98.6466C227.94 100.171 229.675 101.432 230.975 100.501L241.017 93.3226L251.059 100.501C252.359 101.43 254.094 100.17 253.612 98.6466L249.888 86.8776L259.818 79.5446C261.103 78.5956 260.441 76.5556 258.843 76.5436L246.499 76.4476L242.594 64.7376C242.09 63.2216 239.945 63.2216 239.44 64.7376Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.793 100.811L186.888 112.521L174.544 112.617C172.946 112.629 172.283 114.669 173.569 115.618L183.499 122.951L179.775 134.72C179.293 136.244 181.028 137.505 182.328 136.574L192.37 129.396L202.412 136.574C203.712 137.503 205.447 136.243 204.965 134.72L201.241 122.951L211.171 115.618C212.456 114.669 211.794 112.629 210.196 112.617L197.852 112.521L193.947 100.811C193.443 99.2948 191.299 99.2948 190.793 100.811Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.676 100.811L283.771 112.521L271.427 112.617C269.829 112.629 269.166 114.669 270.452 115.618L280.382 122.951L276.658 134.72C276.176 136.244 277.911 137.505 279.211 136.574L289.253 129.396L299.295 136.574C300.595 137.503 302.33 136.243 301.848 134.72L298.124 122.951L308.054 115.618C309.339 114.669 308.677 112.629 307.079 112.617L294.735 112.521L290.83 100.811C290.325 99.2948 288.181 99.2948 287.676 100.811Z",
    fill: "#F5F5F5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3210_7957"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    rx: 256,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSg);
export default __webpack_public_path__ + "static/media/sg.cd6bd314914de730fd989c5d9af12619.svg";
export { ForwardRef as ReactComponent };